import baseAPI from '../../axiosApi'

const api={
    list:'/api-ir/bachelor/course/tqk/page',
    add:'/api-ir/bachelor/course/tqk/add',
    update:'/api-ir/bachelor/course/tqk/edit',
    info:'/api-ir/bachelor/course/tqk/',
    del:'/api-ir/bachelor/course/tqk/',
    export:'/api-ir/bachelor/course/tqk/export'
}
// 查询提前考列表
export function list (data) {
    return baseAPI.axiosData(api.list,'post',data)
}
// 新增提前考
export function add (data) {
    return baseAPI.axiosData(api.add,'post',data)
}
// 修改提前考
export function update (data) {
    return baseAPI.axiosData(api.update,'put',data)
}
// 查询提前考信息
export function info (id) {
    return baseAPI.axiosData(api.info+id,'get')
}
// 删除提前考
export function del (id) {
    return baseAPI.axiosData(api.del+id,'delete')
}

export function exportTable (data) {
    return baseAPI.axiosData(api.export,'post',data)
}